import ContentVisibility from './ContentVisibility'
import { ProfileImage, PromoImage, ThumbnailImage } from './ImageDetail'
import ObjectTypeDetail from './ObjectTypeDetail'
import TagDataReference from './TagDataReference'
import { VideoDetail } from './VideoDetail'

// NOTE: this is in here since the CreatorDetail file points to this file creating a circular dependency.
export const MinimumCreatorDetail = `
  ${ProfileImage}
  ${ContentVisibility}
  fragment MinimumCreatorDetail on CreatorDetail {
    creatorType
    contentLocale
    id
    name
    biography
    sourceId
    url
    profileImage {
      ...ProfileImage
    }
    visibility {
      ...ContentVisibility
    }
  }
`

export const ConferencePromo = `
  ${ThumbnailImage}
  ${PromoImage}
  ${ObjectTypeDetail}
  ${MinimumCreatorDetail}
  ${VideoDetail}
  ${TagDataReference}
  fragment ConferencePromo on ConferencePromo {
    classroomName
    conferenceYear
    contentId
    contentLocale
    contentType {
      ...ObjectTypeDetail
    }
    creators {
      ...MinimumCreatorDetail
    }
    ctaText
    date
    description
    image {
      ...PromoImage
    }
    overlineText
    promoId
    sessionDifficulty
    sessionFormat
    sessionLocation
    tags {
      ...TagDataReference
    }
    title
    thumbnail {
      ...ThumbnailImage
    }
    url
    video {
      ...VideoDetail
    }
  }
`
